import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { firstLetterCapitalize } from '../../../util/text';
import Collapsible from '../../../components/common/Collapsible';


class RefineSearch extends Component {
  courtNameParse = (courtName, courtValue = '') => {
    const nameLengthLimit = courtValue ? 35 : 30;

    courtValue = typeof courtValue === 'number' ? courtValue.toString() : courtValue;

    const courtNameParsedChunkLast = courtValue.length ? ` (${courtValue})` : '';

    if (courtName.length + courtNameParsedChunkLast.length <= nameLengthLimit) {
      return courtName + courtNameParsedChunkLast;
    }

    const courtNameParsedChunkFirst = courtName.substr(0, nameLengthLimit - courtNameParsedChunkLast.length - 1);

    const suffix = (courtName !== 'Default')
      ? `…${courtNameParsedChunkLast}`
      : '';

    return `${courtNameParsedChunkFirst}${suffix}`;
  }

  render() {
    const { facetsData, courtsMap, facets, facetRowClick } = this.props;

    const refinedSearchFacets = Object.keys(facetsData).map((facetName, index) => {
      const value = facets.get(facetName) ? facets.get(facetName).toJS() : {};

      const valueKeys = Object.keys(value);

      const facetRows = [];
      const courtValue = valueKeys[0];
      if (valueKeys.length === 1 && value[courtValue] === -1) {
        // in case if in facets block there was only 1 instance,
        // i.e. we've selected case type or one of the chapters, etc.
        const courtName =
          _.get(courtsMap, `['${courtValue}'][0]['name']`) ||
          firstLetterCapitalize(courtValue);
        const facetRowTitle = this.courtNameParse(courtName);

        const link = (
          <div key={facetRows.length} className="link">
            <span onClick={() => facetRowClick({ [facetName]: null })}
                  className="ir-search-facet-link link-emulated active">
              (-)
            </span> {facetRowTitle}
          </div>
        );
        facetRows.push(link);
      } else if (!_.isEmpty(value)) {
        const facetRowKeys = (facetName === 'court_name')
          ? valueKeys.sort()
          : valueKeys.sort().reverse();

        // in case if in facets block there was only various instances in current facet block
        // that we able to choose one for filter.
        facetRows.push(facetRowKeys.map((facetRowName, idx) => {
          const courtName =
            _.get(courtsMap, `['${facetRowName}'][0]['name']`) ||
            firstLetterCapitalize(facetRowName);
          const nextCourtValue = value[facetRowName];
          const facetRowTitle = this.courtNameParse(courtName, nextCourtValue);

          return (
            <div key={idx} className="link">
              <span
                id={`left-panel-${facetRowName}`}
                onClick={() => facetRowClick({ [facetName]: facetRowName })}
                className="ir-search-facet-link link-emulated active">
                {facetRowTitle}
              </span>
            </div>
          );
        }));
      }

      if (facetRows.length) {
        return (
          <div key={index} className="tab-section">
            <div className="title">
              <h4>{facetsData[facetName]}</h4>
            </div>
            {facetRows}
          </div>
        );
      }
      return (<div />);
    });

    const facetComponents = _.compact(refinedSearchFacets);

    return (
      <Collapsible
        initCollapsed={false}
        title="Refine Search"
        key="refine-search">
        {facetComponents}
      </Collapsible>
    );
  }
}

RefineSearch.defaultProps = {
  facetsData: {},
  courtsMap: {},
  facets: [],
};

RefineSearch.propTypes = {
  facetsData: PropTypes.object,
  courtsMap: PropTypes.object,
  facets: PropTypes.object,
  facetRowClick: PropTypes.func.isRequired,
};

export default RefineSearch;



// WEBPACK FOOTER //
// ./src/pages/filings/FacetsBlock/RefineSearch.jsx